import {
  MapLevelCustomersInput,
  MapLevelDevicesInput,
  UpdateLevelAuthConfigInput,
} from "shared/types/integrations";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

const BASE_URL = import.meta.env.VITE_APP_INTEGRATION_BASE_URL;

export const createLevelAuthConfig = async (api_key: string) => {
  try {
    const url = `${BASE_URL}/level/auth-config`;
    const data = {
      api_key,
    };
    const response = await axiosClient.post(`${url}`, data);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateLevelAuthConfig = async ({
  api_key,
  webhook_url,
  webhook_secret,
  board,
}: UpdateLevelAuthConfigInput) => {
  try {
    const url = `${BASE_URL}/level/auth-config`;
    const data = {
      api_key,
      webhook_url,
      webhook_secret,
      board,
    };
    const response = await axiosClient.put(`${url}`, data);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getLevelAuthConfig = async () => {
  try {
    const url = `${BASE_URL}/level/auth-config`;
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getLevelCustomers = async ({
  perPage = 100,
  startingAfter,
}: {
  perPage?: number;
  startingAfter?: string;
}) => {
  try {
    let url = `${BASE_URL}/level/customers?per_page=${perPage}`;
    if (startingAfter) {
      url += `&starting_after=${startingAfter}`;
    }
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return {
        data: resData?.data || [],
        // hasMore: resData?.has_more || false,
        lastItemId:
          resData?.data?.length > 0
            ? resData?.data?.[resData?.data?.length - 1]?.id
            : null,
      };
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getLevelDevices = async ({
  perPage = 100,
  startingAfter,
}: {
  perPage?: number;
  startingAfter?: string;
}) => {
  try {
    let url = `${BASE_URL}/level/devices?per_page=${perPage}`;
    if (startingAfter) {
      url += `&starting_after=${startingAfter}`;
    }
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return {
        data: resData?.data || [],
        lastItemId:
          resData?.data?.length > 0
            ? resData?.data?.[resData?.data?.length - 1]?.id
            : null,
      };
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const mapLevelCustomers = async (customers: MapLevelCustomersInput) => {
  try {
    const url = `${BASE_URL}/level/map/customers`;
    const data = {
      customers,
    };
    const response = await axiosClient.post(`${url}`, data);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getLevelMappedCustomers = async () => {
  try {
    const url = `${BASE_URL}/level/map/customers`;
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const mapLevelDevices = async (data: MapLevelDevicesInput) => {
  try {
    const url = `${BASE_URL}/level/map/devices`;
    const response = await axiosClient.post(`${url}`, data);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getLevelMappedDevices = async () => {
  try {
    const url = `${BASE_URL}/level/map/devices`;
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const disconnectLevelIntegration = async () => {
  try {
    const url = `${BASE_URL}/v1/level/disconnect`;
    const response = await axiosClient.delete(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateLevelStatus = async (status: boolean) => {
  try {
    const url = `${BASE_URL}/v1/level/msp/configuration/status/${status}`;
    const response = await axiosClient.patch(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
